import moment from 'moment';

import { SpaClassListGroup, SpaClassListItem } from 'voyager';

const MORNING_END_HOUR = 12;
const AFTERNOON_END_HOUR = 17;

type GroupLabels = {
  morning: string;
  morningSub: string;
  afternoon: string;
  afternoonSub: string;
  evening: string;
  eveningSub: string;
};

type ItemWithStart = SpaClassListItem & { startDateTime?: string };

export function groupClassesByTimeOfDay(
  items: SpaClassListItem[],
  resolveStart: (item: SpaClassListItem) => string | undefined,
  labels: GroupLabels
): SpaClassListGroup[] {
  const morning: SpaClassListItem[] = [];
  const afternoon: SpaClassListItem[] = [];
  const evening: SpaClassListItem[] = [];

  items.forEach((item) => {
    const start = resolveStart(item);
    const hour = start ? moment(start).hour() : Number(item.time?.split(':')[0] || 0);
    if (hour < MORNING_END_HOUR) morning.push(item);
    else if (hour < AFTERNOON_END_HOUR) afternoon.push(item);
    else evening.push(item);
  });

  const groups: SpaClassListGroup[] = [];
  if (morning.length > 0)
    groups.push({ id: 'morning', label: labels.morning, subLabel: labels.morningSub, items: morning });
  if (afternoon.length > 0)
    groups.push({
      id: 'afternoon',
      label: labels.afternoon,
      subLabel: labels.afternoonSub,
      items: afternoon,
    });
  if (evening.length > 0)
    groups.push({ id: 'evening', label: labels.evening, subLabel: labels.eveningSub, items: evening });

  return groups;
}

export type { ItemWithStart };
